module.exports = __webpack_public_path__ + "static/media/copenhagen.5d2d4785.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightBrowse/img/destinations/copenhagen.jpg
// module id = 1036
// module chunks = 0